import { createURL } from "./createURL";
import { facetCategoryMap } from "./facetCategoryMap";

/**
 * Algolia needs the query as a 'query' parameter, but requirements ask for the URL to show 'search'
 * so we rename the query value in the destructure here
 * and then set back in urlToSearchState using a replace on the generated string.
 * @param {object} location we use the pathname attribute
 * @param {object} searchState (algolia) destructured to { query<string>, refinementList<array>, sortBy<string>}
 * @param {array} sortList an array of objects that is created by the adaptSort in data-models
 * @returns {string} a URL path that looks like `pathname?search=beta&materials=insulated&sort=name-descending`
*/
export const searchStateToUrl = (location, { query: search, refinementList, sortBy }, sortList = []) => {
  const path = location?.pathname ? location.pathname : "";
  // format refinementList so we have nice looking filters
  let refinements = {};
  if (refinementList) {
    for (const [key, value] of Object.entries(refinementList)) {
      const category = facetCategoryMap[key];
      // change array into a string separated by commas
      refinements[category] = value.toString();
      // if category is empty, remove it from the URL
      if (value.length === 1 && value[0] === "" || !value.length) {
        delete refinements[category];
      }
    }
  }
  // we want to change how sort looks in the URL
  // from: sortBy=prod_arcteryx_product_outdoor_ca_english_name_desc
  // to: sort=name-descending
  // create an empty object so that if there isn't a match below then sort will disappear from the URL
  let sortOption = {};
  // find the replicaName in the sortList which is created from the adaptSort function
  const sortReplicaMatch = sortList?.find(({value: replicaName }) => replicaName === sortBy);
  if (sortReplicaMatch) {
    // use the id attribute which is formatted like name-descending etc.
    sortOption = {
      sort: sortReplicaMatch.id
    };
  }
  // create a nice URL path
  return search ? `${path}${createURL({ search, ...refinements, ...sortOption })}` : "";
};
